module.exports = __webpack_public_path__ + "img/icon-trash.4bd2fb8a.svg";